import {useSelector} from "react-redux"

export class UserPermissionManager {
    constructor() {
        const authUser = useSelector(state => state.auth.user)

        this.restrictions = authUser.user?.restrictions ?? {
            count: 0,
            activeCount: 0,
            data: [],
            active: []
        }
    }

    hasRestriction(restriction) {
        if (this.restrictions.activeCount === 0) {
            return false
        }
        const restrictions = this.restrictions?.active.filter(r => {
            return r.restriction.includes(restriction)
        })

        return restrictions.length > 0
    }
    getRestriction(restriction) {
        if (this.restrictions.activeCount === 0) {
            return null
        }
        return this.restrictions?.active.find(r => r.restriction.includes(restriction))
    }
    canAddingNewCoupon() {
        return !this.hasRestriction("no_adding_coupons")
    }
    restrictionAddingCoupon() {
        return this.getRestriction("no_adding_coupons")
    }

    canAddingComment() {
        return !this.hasRestriction("no_adding_comments")
    }

    canAddingReactions() {
        return !this.hasRestriction("no_adding_reactions")
    }

    canAddingMessageInChats() {
        return !this.hasRestriction("no_adding_messages_in_chats")
    }

    isFullBan() {
        return this.hasRestriction("full_ban")
    }
}